import { LocationScope } from '../types/MenuInterface';

// only sends the multi-location fields when saving beyond the current location
export const buildLocationScopeBody = (locationScope: LocationScope, restaurantIDs?: number[]) => ({
  ...(locationScope !== 'single' && { locationScope }),
  ...(locationScope === 'selected' && { restaurantIDs })
});

// targets another location's copy of a record; apiClient only sets restaurantID when it's missing
export const restaurantHeaders = (restaurantID?: number) =>
  restaurantID ? { headers: { restaurantID: `${restaurantID}` } } : undefined;
